export default __webpack_public_path__ + "static/media/new-contactus.dc36b9b2.jpg";